import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from './../components/Login'

import RegisterMailSent from './../components/RegisterMailSent'
import RegisterUser from "../components/RegisterUser";
import RegisterSuccess from './../components/RegisterSuccess'

import InviteJoin from './../components/InviteJoin'
import InviteRegister from './../components/InviteRegister'

import RequestPasswordReset from './../components/RequestPasswordReset'
import RequestPasswordResetSuccess from './../components/RequestPasswordResetSuccess'
import ResetPassword from './../components/ResetPassword'
import ResetPasswordSuccess from './../components/ResetPasswordSuccess'
import RegisterUserExists from "../components/RegisterUserExists";
import RegisterUser2 from "@/components/RegisterUser2";
import RegisterAssistant from "@/components/RegisterAssistant";
import TrialLandingPage from "@/components/TrialLandingPage";
import LoginPassword from "../components/LoginPassword";

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/login',
}, {
    path: '/login',
    name: 'login',
    component: Login
}, {
    path: '/loginPassword',
    name: 'loginPassword',
    component: LoginPassword
}, {
    path: "/register/sent",
    component: RegisterMailSent
}, {
    path: "/register",
    name: 'register',
    component: RegisterUser
}, {
    path: "/register2",
    name: 'register2',
    component: RegisterUser2
}, {
    path: "/register/assistant",
    name: 'register_assistant',
    component: RegisterAssistant
}, {
    path: '/register/success',
    name: 'register_success',
    component: RegisterSuccess
}, {
    path: '/register/exists',
    name: 'register_exists',
    component: RegisterUserExists
}, {
    path: '/invitation/register',
    name: 'invitation_register',
    component: InviteRegister
}, {
    path: '/invitation/join',
    name: 'join',
    component: InviteJoin
}, {
    path: '/reset',
    name: 'requestPasswordReset',
    component: RequestPasswordReset
}, {
    path: '/reset/success',
    name: 'requestPasswordResetSuccess',
    component: RequestPasswordResetSuccess,
}, {
    path: '/reset/enter',
    name: 'resetPassword',
    component: ResetPassword,
}, {
    path: '/reset/enter/success',
    name: 'resetPasswordSuccess',
    component: ResetPasswordSuccess,
}, {
    path: '/trial/login/',
    name: 'trialLogin',
    component: TrialLandingPage
}, {
    path: '*',
    redirect: '/login',
    name: '404'
}
]

const Router = new VueRouter({
    base: '/user',
    routes
})

/**
 * If next route has no GET params, use old ones
 */
Router.beforeEach((to, from, next) => {
    if(from.query.token && !to.query.token) {
        if(to.path === from.path) {
            return
        }

        next({path: to.path, query: from.query})
    }

    next()
})

export default Router;
